// src/super_admin/CompanyDetails.js
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

function CompanyDetails() {
  const { companyId } = useParams();
  const [company, setCompany] = useState(null);
  const [users, setUsers] = useState([]);
  const [error, setError] = useState("");

  // Stati per la funzionalità di reset password
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUsername, setSelectedUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    fetchCompanyAndUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  const fetchCompanyAndUsers = async () => {
    try {
      setError("");
      const token = localStorage.getItem("access_token");

      // 1) GET /super_admin/companies/{companyId} (dettagli compagnia)
      const resComp = await fetch(
        `${process.env.REACT_APP_API_URL}/super_admin/companies/${companyId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!resComp.ok) {
        const errData = await resComp.json();
        throw new Error(errData.detail || "Errore fetch compagnia");
      }
      const dataComp = await resComp.json();
      setCompany(dataComp);

      // 2) GET /super_admin/companies/{companyId}/users
      const resUsers = await fetch(
        `${process.env.REACT_APP_API_URL}/super_admin/companies/${companyId}/users`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!resUsers.ok) {
        const errData = await resUsers.json();
        throw new Error(errData.detail || "Errore fetch utenti");
      }
      const dataUsers = await resUsers.json();
      setUsers(dataUsers);
    } catch (err) {
      setError(err.message);
    }
  };

  // Apertura del modal di reset password
  const handleOpenResetPassword = (userId, username) => {
    setSelectedUserId(userId);
    setSelectedUsername(username);
    setNewPassword("");
    setSuccessMsg("");
    setError("");
    setShowModal(true);
  };

  // Chiusura del modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedUserId(null);
    setSelectedUsername("");
    setNewPassword("");
    setSuccessMsg("");
    setError("");
  };

  // Funzione che fa la PUT per resettare la password
  const handleResetPassword = async () => {
    try {
      setError("");
      setSuccessMsg("");
      if (!newPassword.trim()) {
        throw new Error("Inserisci la nuova password!");
      }

      const token = localStorage.getItem("access_token");
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/super_admin/users/${selectedUserId}/reset_password`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ new_password: newPassword }),
        }
      );

      if (!res.ok) {
        const dataErr = await res.json();
        throw new Error(dataErr.detail || "Errore reset password");
      }

      const data = await res.json();
      setSuccessMsg(data.message); // "Password ... resettata con successo."

      // Esempio: chiudiamo il modal dopo 1 secondo, così l'utente vede il messaggio
      setTimeout(() => {
        handleCloseModal();
      }, 1000);

      // Se preferisci chiusura immediata:
      // handleCloseModal();

    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div>
      <h1>Dettagli Compagnia {companyId}</h1>
      {error && <p style={{ color: "red" }}>{error}</p>}

      {company ? (
        <div>
          <p>ID: {company.id}</p>
          <p>Nome: {company.name}</p>
        </div>
      ) : (
        <p>Caricamento compagnia...</p>
      )}

      <h2>Utenti associati</h2>
      <Link to="add_user">Aggiungi nuovo utente</Link>
      <table border="1" cellPadding="5" style={{ marginTop: "10px" }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Username</th>
            <th>Email</th>
            <th>Ruolo</th>
            <th>Azioni</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.id}>
              <td>{u.id}</td>
              <td>{u.username}</td>
              <td>{u.email}</td>
              <td>{u.role}</td>
              <td>
                {/* Pulsante "Reset Password" */}
                <button onClick={() => handleOpenResetPassword(u.id, u.username)}>
                  Reset Password
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal di reset password */}
      {showModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h3>Reset Password per {selectedUsername} (ID: {selectedUserId})</h3>
            {error && <p style={{ color: "red" }}>{error}</p>}
            {successMsg && <p style={{ color: "green" }}>{successMsg}</p>}

            <label>Nuova Password: </label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <div style={{ marginTop: "10px" }}>
              <button onClick={handleResetPassword}>Conferma</button>
              <button onClick={handleCloseModal} style={{ marginLeft: "10px" }}>
                Annulla
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CompanyDetails;

// Stili rapidi per il modal (puoi usare librerie dedicate se preferisci)
const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  modalContent: {
    background: "#fff",
    padding: "20px",
    borderRadius: "8px",
    width: "400px",
  },
};
